export default __webpack_public_path__ + "static/media/blue-loader.d4933a66.svg";